import { VergersEcoresponsablesComponent } from './vergers-ecoresponsables.component';

export const VERGERS_ECORESPONSABLES_ROUTES = [
    {
        path: '',
        component: VergersEcoresponsablesComponent,
        data: {
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.vergers-ecoresponsable'
            }
        }
    }
];
